import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowDownCircle } from 'lucide-react';
import { Modal } from './ui/Modal';
import './UpdateModal.css';

const UpdateModal = ({
  isOpen,
  onClose,
  currentVersion,
  latest,
  offeredVersion,
  onInstall,
  onLater,
  onSkipVersion,
  installing,
  error,
}) => {
  const { t } = useTranslation();
  // What is on offer for THIS platform, not the manifest headline — a
  // carried-forward entry names a build the user is not getting, and the Skip
  // button is about to name a version.
  const latestVersion = offeredVersion || latest?.version || '';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('update.title')}
      subtitle="A new version of Apiboo is available"
      customIcon={<ArrowDownCircle size={24} className="text-blue-500" />}
      preventBackdropClose={installing}
      preventEscapeClose={installing}
    >
      <div className="space-y-4">
        <p className="update-modal__line">
          {t('update.versionLine', { current: currentVersion, latest: latestVersion })}
        </p>

        {latest?.notes ? (
          <div className="update-modal__notes">
            <p>{latest.notes}</p>
          </div>
        ) : null}

        {error ? (
          <p className="update-modal__error" role="alert">
            {error}
          </p>
        ) : null}

        <div className="update-modal__actions flex justify-end gap-2 pt-1">
          <button
            type="button"
            onClick={onSkipVersion}
            disabled={installing}
            className="modal-btn-cancel"
          >
            {t('update.skipVersion')}
          </button>
          <button
            type="button"
            onClick={onLater}
            disabled={installing}
            className="modal-btn-ghost"
          >
            {t('update.later')}
          </button>
          <button
            type="button"
            onClick={onInstall}
            disabled={installing}
            className="rounded-xl bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700 disabled:opacity-50"
          >
            {installing ? t('update.installing') : t('update.install')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UpdateModal;
